module.exports = __webpack_public_path__ + "img/report.0a5a4931.jpg";